import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const winWidth = document.body.clientWidth || document.documentElement.clientWidth
export default new Vuex.Store({
  state: {
    isPc: winWidth >= 768,
    activedPath: '',
    swiperOptions: {
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      speed: 1000,
      observer: true,
      centeredSlides: true,
      preventClicksPropagation: true
    }
  },
  mutations: {
    setActivedPath: (state, path = '') => {
      state.activedPath = path
    }
  },
  actions: {

  }
})
